(function (angular) {
	'use strict';

	var opportunityFundTargetMarketsObject = {
		templateUrl: [
			'STATIC_BASE_PATH',
			templateUrlFunction
		],
		controller: [
			'$scope',
			'globalConfig',
			'STATIC_BASE_PATH',
			'mixpanelFactory',
			'urlFactory',
			OpportunityFundTargetMarketsFunction
		],
		controllerAs: 'opportunityFundTargetMarkets'
	};

	angular
		.module('productPage')
		.component('opportunityFundTargetMarkets', opportunityFundTargetMarketsObject);

	function templateUrlFunction(STATIC_BASE_PATH){
		return STATIC_BASE_PATH + '/static/html/opportunity-fund/opportunity-fund-target-markets.html';
	}

	function OpportunityFundTargetMarketsFunction(
		$scope,
		globalConfig,
		STATIC_BASE_PATH,
		mixpanelFactory,
		urlFactory) {
		
		var opportunityFundTargetMarkets = this;

		opportunityFundTargetMarkets.staticBasePath = STATIC_BASE_PATH;

		opportunityFundTargetMarkets.data = {
			atlanta: {
				name: 'Atlanta',
				description: 'The economic and cultural center of the South is undergoing a massive urban revitalization spurred by job growth and an influx of millenials with a preference for city living.',
				mapImgSrc: STATIC_BASE_PATH + '/images/marketing/opportunity-fund/map-images/atlanta-map.png',
				neighborhoods: [{
					name: 'Bankhead',
					walkScore: 52,
					transitScore: 51,
					fiveYrAvgPriceGrowth: '52%'
				},{
					name: 'Grove Park',
					walkScore: 38,
					transitScore: 43,
					fiveYrAvgPriceGrowth: '52%'
				},{
					name: 'English Avenue',
					walkScore: 66,
					transitScore: 46,
					fiveYrAvgPriceGrowth: '52%'
				}],
				bgImgSrc: STATIC_BASE_PATH + '/images/marketing/real-estate-markets/atlanta-hero-fullsize.jpg'
			},
			losAngeles: {
				name: 'Los Angeles',
				description: 'The City of Angels boasts the nation’s second-largest economy — and a massive housing shortage. For those who can navigate the complexities of building in LA, opportunities abound.',
				mapImgSrc: STATIC_BASE_PATH + '/images/marketing/opportunity-fund/map-images/los-angeles-map.png',
				neighborhoods: [{
					name: 'Downtown LA',
					walkScore: 95,
					transitScore: 98,
					fiveYrAvgPriceGrowth: '46%'
				},{
					name: 'South Los Angeles',
					walkScore: 78,
					transitScore: 62,
					fiveYrAvgPriceGrowth: '81%'
				},{
					name: 'Koreatown',
					walkScore: 91,
					transitScore: 73,
					fiveYrAvgPriceGrowth: '47%'
				}],
				bgImgSrc: STATIC_BASE_PATH + '/images/marketing/real-estate-markets/los-angeles-hero-fullsize.jpg'
			},
			sanFrancisco: {
				name: 'San Francisco Bay Area',
				description: 'Throughout the Bay Area, especially in San Jose and Oakland, are emerging neighborhoods ripe for investment as companies and individuals are priced out of San Francisco.',
				mapImgSrc: STATIC_BASE_PATH + '/images/marketing/opportunity-fund/map-images/san-francisco-map.png',
				neighborhoods: [{
					name: 'Downtown San Jose',
					walkScore: 77,
					transitScore: 62,
					fiveYrAvgPriceGrowth: '95%'
				},{
					name: 'Outer Mission',
					walkScore: 84,
					transitScore: 76,
					fiveYrAvgPriceGrowth: '67%'
				},{
					name: 'Downtown Oakland',
					walkScore: 97,
					transitScore: 87,
					fiveYrAvgPriceGrowth: 'No data'
				}],
				bgImgSrc: STATIC_BASE_PATH + '/images/marketing/real-estate-markets/san-francisco-hero-fullsize-2.jpg'
			},
			seattle: {
				name: 'Seattle',
				description: 'The capital of the Pacific Northwest is a tech mecca situated on a narrow strip of land. Scarcity of land combined with massive wealth creation has driven nation-leading price appreciation.',
				mapImgSrc: STATIC_BASE_PATH + '/images/marketing/opportunity-fund/map-images/seattle-map.png',
				neighborhoods: [{
					name: 'Beacon Hill',
					walkScore: 63,
					transitScore: 56,
					fiveYrAvgPriceGrowth: '106%'
				},{
					name: 'International District',
					walkScore: 97,
					transitScore: 100,
					fiveYrAvgPriceGrowth: 'No data'
				},{
					name: 'Squire Park',
					walkScore: 88,
					transitScore: 72,
					fiveYrAvgPriceGrowth: '88%'
				}],
				bgImgSrc: STATIC_BASE_PATH + '/images/marketing/local-real-estate-landing-pages/seattle-hero-fullsize.jpg'
			},
			washingtonDC: {
				name: 'Washington, DC',
				description: 'The national capital and its suburbs form a fast-growing and dynamic market uniquely insulated from national economic downturns by the federal government.',
				mapImgSrc: STATIC_BASE_PATH + '/images/marketing/opportunity-fund/map-images/washington-dc-map.png',
				neighborhoods: [{
					name: 'LeDroit Park',
					walkScore: 88,
					transitScore: 74,
					fiveYrAvgPriceGrowth: '64%'
				},{
					name: 'Brentwood',
					walkScore: 74,
					transitScore: 60,
					fiveYrAvgPriceGrowth: '66%'
				},{
					name: 'Brightwood Park',
					walkScore: 79,
					transitScore: 65,
					fiveYrAvgPriceGrowth: '58%'
				}],
				bgImgSrc: STATIC_BASE_PATH + '/images/marketing/real-estate-markets/washington-dc-hero-fullsize-2.jpg'
			}
		};

		opportunityFundTargetMarkets.select = function(market) {
			opportunityFundTargetMarkets.selectedMarket = opportunityFundTargetMarkets.data[market];
			mixpanelFactory.track('Target Market Selected', {'Market': opportunityFundTargetMarkets.data[market].name});
		};

		opportunityFundTargetMarkets.$onInit = function () {
			opportunityFundTargetMarkets.selectedMarket = opportunityFundTargetMarkets.data.sanFrancisco;
		};
	}
})(window.angular);